export const styles = {
  footer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",

    padding: "20px 40px",

    "@media (max-width: 600px)": {
      padding: "20px 16px",
    },

    "@media (max-width: 400px)": {
      flexDirection: "column-reverse",
    },
  },

  withSocials: {
    justifyContent: "space-between",
  },
};
